export const forgotPasswordRoutePath = '/forgot-password';
